import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ChangePasswordService } from "../../services/change-password.service";
import { ErrorHandlerService } from "src/app/shared/error-handler.service";

@Component({
  selector: "app-change-password-form",
  templateUrl: "./change-password-form.component.html",
  styleUrls: ["./change-password-form.component.css"],
})
export class ChangePasswordFormComponent {
  isSaving: boolean = false;
  isCurrentPasswordVisible: boolean = false;
  isNewPasswordVisible: boolean = false;
  isConfirmPasswordVisible: boolean = false;

  passwordForm = new FormGroup({
    currentPassword: new FormControl(null),
    newPassword: new FormControl(null, Validators.minLength(3)),
    confirmPassword: new FormControl(null, Validators.minLength(3)),
  });

  constructor(
    private router: Router,
    private changePasswordService: ChangePasswordService,
    private toast: ToastrService,
    private errorHandlerService: ErrorHandlerService,
  ) {}

  onSubmit(): void {
    const newPassword = this.passwordForm.get("newPassword").value;
    const confirmPassword = this.passwordForm.get("confirmPassword").value;
    if (newPassword != confirmPassword) {
      this.toast.error("As novas senhas não são iguais, por favor revise os valores informados.");
      return;
    }

    this.isSaving = true;
    const currentPassword = this.passwordForm.get("currentPassword").value;

    this.changePasswordService.changePassword(currentPassword, newPassword, confirmPassword).subscribe({
      next: () => {
        this.isSaving = false;
        this.toast.success("🎉 Senha alterada com sucesso!");
        this.router.navigate(["home"]);
      },
      error: (error) => {
        this.errorHandlerService.handle(error, "Erro ao redefinir a senha.");
        this.isSaving = false;
      },
    });
  }

  toggleCurrentPasswordVisibility(): void {
    this.isCurrentPasswordVisible = !this.isCurrentPasswordVisible;
  }

  toggleNewPasswordVisibility(): void {
    this.isNewPasswordVisible = !this.isNewPasswordVisible;
  }

  toggleConfirmPasswordVisibility(): void {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }

  validateFields(): boolean {
    return (
      this.passwordForm.get("currentPassword").value != null &&
      this.passwordForm.get("newPassword").value != null &&
      this.passwordForm.get("confirmPassword").value != null &&
      this.passwordForm.valid
    );
  }
}
